import { ENV_GOOGLE_MAPS_API_KEY, ENV_API_BASE_URL } from "./env";
import { GOOGLE_ADDRESS_VALIDATION_BASE_URL } from "@/constants/google";

const API_BASE_URL = ENV_API_BASE_URL;

export const GOOGLE_ADDRESS_VALIDATION_URL = `${GOOGLE_ADDRESS_VALIDATION_BASE_URL}?key=${ENV_GOOGLE_MAPS_API_KEY}`;

export const API_ENDPOINTS = {
  getUser: () => `${API_BASE_URL}/profile`,
  updateProfile: () => `${API_BASE_URL}/profile`,
  getProfileOptions: () => `${API_BASE_URL}/localization/lookups`,
  getMfaSettings: () => `${API_BASE_URL}/profile/mfa`,
  deleteMfaMethod: (methodId: string) =>
    `${API_BASE_URL}/profile/mfa/${encodeURIComponent(methodId)}`,
  getPasskeys: () => `${API_BASE_URL}/profile/passkeys`,
  deletePasskey: (passkeyId: string) =>
    `${API_BASE_URL}/profile/passkeys/${encodeURIComponent(passkeyId)}`,
  getOrganization: () => `${API_BASE_URL}/organizations`,
  getTenantSettings: () => `${API_BASE_URL}/tenants/settings`,
  getProfileLocaleWithName: () => `${API_BASE_URL}/profile/locale-name`,
  invalidateMfaRememberBrowser: () =>
    `${API_BASE_URL}/profile/mfa/invalidate-remember-browser`,
  getLocales: () => `${API_BASE_URL}/locales`,
  getApplications: () => `${API_BASE_URL}/applications`,
  getOrgUsers: () => `${API_BASE_URL}/org-admin/users`,
  deleteOrgUsers: () => `${API_BASE_URL}/org-admin/users`,
  getOrgRoles: () => `${API_BASE_URL}/org-admin/roles`,
  assignUserRoles: () => `${API_BASE_URL}/org-admin/users/roles`,
  removeUserRoles: () => `${API_BASE_URL}/org-admin/users/roles`,
  getOrgUserDetails: () => `${API_BASE_URL}/org-admin/users/details`,
  inviteOrgUsers: () => `${API_BASE_URL}/org-admin/invitations`,
};
